import { createTheme } from '@mui/material/styles'
import * as Color from '@mui/material/colors'

export const lightTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: Color.lightBlue[500]
    },
    secondary: {
      main: Color.blue[500]
    }
  }
})

export const darkTheme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: Color.orange[500]
    },
    secondary: {
      main: Color.deepOrange[900]
    }
  },
  overrides: {
    MuiInputBase: {
      input: {
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color'
        }
      }
    }
  }
})
